import { render, staticRenderFns } from "./EditableCheckboxItem.vue?vue&type=template&id=1390fc89&scoped=true&"
import script from "./EditableCheckboxItem.vue?vue&type=script&lang=ts&"
export * from "./EditableCheckboxItem.vue?vue&type=script&lang=ts&"
import style0 from "./EditableCheckboxItem.vue?vue&type=style&index=0&id=1390fc89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390fc89",
  null
  
)

export default component.exports